// src/translations.js

export const translations = {
  nl: {
    // --- Toegangsweigeringen ---------------------------------------------
    // Gekoppeld aan de `error` code die de backend teruggeeft (route_guard.py),
    // niet aan de Engelse tekst ernaast. utils/apiErrors.js zoekt hier eerst
    // en valt daarna terug op het `message` veld van de server.
    error_insufficient_permissions: "Je account heeft alleen leesrechten en kan hier geen wijzigingen doen.",
    error_access_denied: "Je account heeft geen toegang tot deze tool. Vraag een SuperAdmin om je toe te voegen.",
    error_domain_not_recognized: "Je organisatie is niet geregistreerd in dit portaal. Neem contact op met je Xebia-contactpersoon om toegang te regelen.",
    error_no_hosted_domain: "Meld je aan met het werkaccount van je organisatie. Persoonlijke Google-accounts kunnen hier niet worden gebruikt.",
    error_access_disabled: "De toegang van je account is uitgeschakeld.",
    error_invalid_role: "Je account heeft een onbekende rol. Neem contact op met een SuperAdmin.",
    error_customer_out_of_scope: "Je hebt geen toegang tot deze klant.",
    error_field_not_editable: "Sommige van deze gegevens kunnen alleen door ons worden gewijzigd. Neem contact op met support.",
    error_endpoint_not_authorized: "Deze actie is niet beschikbaar.",
    error_missing_bearer_token: "Je sessie is verlopen. Log opnieuw in.",
    error_invalid_token: "Je sessie is verlopen. Log opnieuw in.",
    error_internal_server_error: "Er is een onverwachte fout opgetreden.",
    error_firestore_unavailable: "De database is tijdelijk niet beschikbaar. Probeer het opnieuw.",
    readonly_notice: "Je kunt alles op deze pagina bekijken, maar je hebt geen rechten om hier wijzigingen te maken. Acties die gegevens wijzigen zijn daarom verborgen.",
    profile_readonly_notice: "Je account kan deze gegevens bekijken maar niet wijzigen. Neem contact op met een beheerder als er iets bijgewerkt moet worden.",

    // Header & Algemeen
    logout: "Uitloggen",
    tour_button: "Rondleiding",
    summon_tour: "Start Rondleiding",
    tour_customer_selector: "Selecteer een klant om het dashboard te bekijken.",
    tour_customer_summary: "Bekijk hier de basisgegevens van de geselecteerde klant.",
    tour_subscriptions_table: "Beheer actieve licenties, verleng of voeg extra licenties toe.",
    tour_cart: "Bekijk de items in je winkelmandje en rond de bestelling af.",
    tour_extra_products: "Ontdek en voeg extra producten toe aan je winkelmandje.",
    joyride_back: "Vorige",
    joyride_close: "Sluiten",
    joyride_last: "Klaar",
    joyride_next: "Volgende",
    joyride_skip: "Overslaan",
    loading: "Laden...",
    not_applicable: "N.v.t.",
    no_data_found: "Geen gegevens gevonden.",

    // Login Pagina
    login_title: "Reseller Portal",
    login_message: "Log in om door te gaan.",

    // Hoofdpagina
    my_overview: "Mijn Overzicht",
    primary_domain: "Primair Domein",
    support_hours: "Beschikbare Supporturen",
    customer_selection: "Klantselectie",
    choose_customer: "Kies klant",
    has_access: "Heeft Toegang",
    no_access: "Geen Toegang",
    postpaid_customer: "Postpaid Klant",
    prepaid_customer: "Prepaid Klant",
    active: "Actief",
    inactive: "Inactief",
    saved: "Opgeslagen.",
    save_failed: "Opslaan mislukt.",
    save: "Toepassen",
    loading_details: "Gegevens ophalen...",
    closed_tickets: "Gesloten Tickets",
    ticket_key: "Ticket ID",
    summary: "Onderwerp",
    date: "Datum",
    time_spent: "Tijd Besteed",
    no_tickets_found: "Geen tickets gevonden.",
    close: "Sluiten",
    hours: "uur",
    minutes: "minuten",
    max_hours_error: "Kan niet meer dan 40 uur in winkelmandje plaatsen.",

    // Producttabel
    product: "Product",
    total: "Totaal",
    in_use: "In Gebruik",
    renewal_date: "Verlengdatum",
    add_licenses: "Licenties Toevoegen",
    add_to_cart: "Toevoegen aan winkelmandje",
    subscribe_to_annual: "Abonneren (jaarlijks)",
    per_license_year: "p/licentie per jaar",
    added_to_cart: "Licenties toegevoegd aan winkelmandje!",
    no_renewable_licenses: "Geen verlengbare licenties gevonden.",
    no_prices_found: "Kan de prijs van geen enkele licentie bepalen.",
    renewal_items_skipped: "Geen prijs bekend voor: {items}. Deze zijn niet toegevoegd.",
    calculating_renewal_cost: "Totale verlengingskosten berekenen...",
    error_calculating_renewals: "Fout bij het berekenen van verlengingen.",
    payment_system_not_ready: "Betaalsysteem is niet gereed. Probeer het later opnieuw.",
    quantity_placeholder: "Aantal",
    extra_products_and_services: "Extra producten & diensten",
    cant_find_product: "Product niet gevonden?",
    request_custom_order: "Maatwerk Aanvraag",
    additional_notes: "Aanvullende opmerkingen",
    cancel: "Annuleren",
    submit_request: "Verzoek indienen",
    sending: "Verzenden",
    describe_request: "Beschrijf je aanvraag",
    renew_reminder: "Verlenging in {days} dagen",
    renewal: "Verlenging",
    renew_all_licenses: "Alle licenties verlengen",
    auto_renew: "Auto renew",

    // Extra Producten
    extra_products_services: "Extra Producten en Diensten",

    // Winkelmandje
    shopping_cart: "Winkelmandje",
    empty_cart: "Je winkelmandje is leeg.",
    added_to_cart_success: "is toegevoegd aan je winkelmandje.",
    item: "Item",
    quantity: "Aantal",
    action: "Actie",
    remove: "Verwijder",
    place_order: "Bestelling Plaatsen",
    order_placed_success: "Bestelling succesvol geplaatst!",
    cannot_place_order_alert: "Kan bestelling niet plaatsen: geen klant geselecteerd of winkelmandje is leeg.",
    order_placed_success_message: "Bestelling succesvol geplaatst! Order ID:",
    payment_success_invoice_email: "Betaling geslaagd. De factuur wordt naar uw e-mail verzonden.",
    payment_success_processed: "Betaling geslaagd. Uw bestelling is verwerkt.",
    payment_failed_authentication: "De betaling is mislukt of geannuleerd. Probeer het opnieuw of kies een andere betaalmethode.",
    order_placed_error: "Er is een fout opgetreden bij het plaatsen van de bestelling.",
    success_title: "Succes",
    error_title: "Fout",
    payment_details: "Betalingsgegevens",
    yearly_price: "Jaarprijs",
    remain_days: "Resterende dagen",
    subtotal: "Subtotaal",
    vat: "BTW",
    purchase_order: "Inkooporder (Optioneel)",

    // Bestelgeschiedenis
    order_history: "Bestelgeschiedenis",
    back_to_dashboard: "Terug naar Dashboard",
    invoice_number: "Factuurnummer",
    status: "Status",
    view_invoice: "Bekijk Factuur",
    no_orders_found: "Geen bestellingen gevonden.",
    total_amount: "Totaalbedrag",
    ordered_by: "Besteld door",
    pay: "Betalen",
    pay_with_stripe: "Betalen met Stripe",
    paying: "Bezig...",
    copy_payment_link: "Betaallink kopiëren",
    payment_link_copied: "Betaallink gekopieerd naar klembord!",
    copied: "Gekopieerd!",
    tc_agree: "Ik ga akkoord met de",
    tc_terms: "Algemene Voorwaarden",
    tc_error: "Ga akkoord met de Algemene Voorwaarden om door te gaan.",

    // Public payment page
    payment_page_title: "Factuurbetaling",
    order_details: "Bestelgegevens",
    invoice_for_order: "Factuur voor bestelling",
    item_name: "Naam",
    item_description: "Omschrijving",
    item_price: "Prijs (€)",
    item_quantity: "Aantal",
    item_subtotal: "Subtotaal",
    order_already_paid: "Deze bestelling is reeds betaald.",
    order_already_paid_desc: "Bedankt voor uw betaling. Uw services en licenties worden automatisch verwerkt.",
    download_invoice_pdf: "Factuur downloaden (PDF)",
    order_not_found: "Bestelling niet gevonden",
    order_not_found_desc: "De opgegeven factuur of bestelling kon niet worden gevonden. Controleer het factuurnummer in de URL of neem contact op met onze support.",
    secure_payment_stripe_desc: "Veilig en direct afrekenen via Stripe (ondersteunt iDEAL, Creditcard, Bancontact en meer).",
    payment_successful: "Betaling succesvol verwerkt!",
    payment_cancelled: "Betaling geannuleerd. U kunt het op elk gewenst moment opnieuw proberen.",
    thank_you_payment_for: "Bedankt voor uw betaling voor",
    payment_success_desc: "Uw betaling is succesvol ontvangen. Uw Google Workspace licenties en diensten worden automatisch bijgewerkt en geactiveerd.",
    payment_reference: "Factuurnummer",
    amount_paid: "Betaald bedrag",
    status_completed: "Afgerond & Betaald",
    show_details: "Besteloverzicht bekijken",
    hide_details: "Besteloverzicht verbergen",
    suspended_workspace_notice: "Kunt u niet inloggen vanwege een opgeschort Google Workspace account? U kunt deze factuur direct hieronder voldoen om uw diensten te hervatten.",
    need_help: "Hulp nodig?",
    contact_support: "Neem contact op met support",

    // Workspaces
    workspace_plans: "Workspace Abonnementen (Jaarlijks)",
    search_workspace_plans: "Abonnementen zoeken...",
    afas_artikelcode: "AFAS Artikel Code",
    price: "Prijs (€)",
    related_licenses_sku: "Gerelateerde SKU",
    visible: "Zichtbaar",
    order: "Volgorde",
    icon: "Icoon Key",
    category: "Categorie",
    no_search_results: "Geen resultaten gevonden voor jouw zoekopdracht.",
    load_more_failed: "Meer transacties laden is mislukt.",
    retry: "Opnieuw proberen",
    related_sku: "Gerelateerde SKU",
    contact_admin_to_update_price: "Neem contact op met de beheerder om de prijs bij te werken.",
    afas_artikelcode_empty: "AFAS artikelcode is leeg.",
    cannot_make_visible: "Kan niet zichtbaar gemaakt worden",
    cannot_make_visible_both_reason: "prijs is €0 en AFAS artikelcode is leeg",
    cannot_make_visible_price_reason: "prijs is €0",
    cannot_make_visible_afas_reason: "AFAS artikelcode is leeg",
    cannot_be_visible_warning: "Kan niet zichtbaar zijn omdat de prijs €0 is of de AFAS artikelcode leeg is.",
    admin_webshop: "Webshops",
    actions: "Acties",
    add_new_item: "Nieuw item toevoegen",
    edit_item: "Item bewerken",
    delete_item_confirmation: "Weet je zeker dat je dit item wilt verwijderen?",
    delete: "Verwijderen",
    saving: "Opslaan...",
    save_changes: "Wijzigingen opslaan",
    no_item_found: "Geen items gevonden.",
    sku_help_text: "Heeft u SKU- of product-ID's nodig? Raadpleeg de ",
    google_workspace_docs: "Google Workspace-documentatie",
    google_reseller_docs: "Google Reseller-documentatie",
    no_subscriptions_found: "Geen actieve licenties gevonden voor deze klant.",
    profile: "Profiel",
    customer_name_placeholder: "Voer bedrijfs- of klantnaam in",
    address1: "Adresregel 1",
    address1_placeholder: "Vleugel, verdieping of unit, straatnaam en nummer",
    address2: "Adresregel 2",
    address2_placeholder: "Postcode en stad",
    country: "Land",
    country_placeholder: "Voer land in (bijv. Nederland)",
    contact_email: "Contact E-mail",
    contact_email_placeholder: "facturatie@voorbeeld.nl, info@voorbeeld.nl",
    contact_email_hint: "Scheid meerdere e-mailadressen met komma's",
    profile_saved: "Profiel succesvol opgeslagen",
    profile_save_error: "Fout bij het opslaan van het profiel",
    changes_discarded: "Wijzigingen ongedaan gemaakt",
    vat_number: "BTW-nummer",
    vat_number_placeholder: "Vat nummer (bijv. NL123456789B01)",
    vat_validating: "BTW-nummer valideren...",
    vat_valid: "BTW-nummer is geldig",
    vat_invalid: "BTW-nummer is ongeldig",
    vat_validation_error: "BTW-validatie niet beschikbaar",
    vat_mismatch_warning: "Waarschuwing: Bedrijfsnaam of adres wijkt af van het BTW-register",
    emergency_email: "Emergency E-mail",
    emergency_email_placeholder: "emergency@voorbeeld.nl",
    emergency_email_hint: "E-mailadres voor noodgevallen dat buiten uw domein valt.",

    admin_email_template: "Email Templates",

    // Renewal Reminders
    renewal_reminders: {
      days_30: "Tijd om te verlengen! Uw Google Workspace licenties verlopen over 30 dagen. Klik hier om uw factuur te voldoen en onderbrekingen te voorkomen.",
      days_15: "Herinnering: Uw licenties verlopen over 15 dagen. Voorkom dat uw domein wordt gedeactiveerd door nu te betalen in de Xebia webshop.",
      days_7: "Belangrijk: Nog maar 7 dagen tot de vervaldatum. We hebben uw betaling nog niet ontvangen. Het Phoenix-team is op de hoogte gesteld.",
      days_2: "LAATSTE KANS: Uw toegang tot Google Workspace stopt over 48 uur. Betaal onmiddellijk om dataverlies te voorkomen.",
      days_0: "Toegang opgeschort: Uw licenties zijn verlopen. Uw diensten zijn nu inactief. Betaal vandaag om uw account te heractiveren.",
      lost: "Account verwijderd: Vanwege het uitblijven van betaling is uw abonnement beëindigd. Neem contact op met support voor eventuele herstelmogelijkheden."
    },

    // Admin Renewal Status
    admin_renewal_status: "Verlengingsstatus",
    renewal_status_description: "Welke klanten in deze maand moeten verlengen, en of ze dat al gedaan hebben.",
    renewal_due: "Te verlengen",
    renewal_renewed: "Verlengd",
    renewal_open: "Open",
    renewal_payment_pending: "Betaling in behandeling",
    renewal_not_renewed: "Niet verlengd",
    renewal_no_order: "Verlengd zonder order",
    renewal_no_order_hint: "Google heeft verlengd, maar er is geen betaalde of gefactureerde order.",
    renewal_switched: "Overgestapt naar flexibel",
    range_start: "Begin",
    range_today: "Vandaag",
    renewal_setting_renew: "Verlengt automatisch",
    renewal_setting_cancel: "Stopt op einddatum",
    renewal_setting_switch: "Wordt flexibel abonnement",
    renewal_progress: "{renewed}/{total} verlengd",
    renewal_subscriptions: "Abonnementen",
    renewal_type: "Type",
    renewal_type_col: "Verlengingstype",
    renewal_order: "Order",
    renewal_other_month: "Andere maand",
    renewal_none: "Geen klanten met een verlenging in deze maand.",
    renewal_none_filtered: "Geen klanten gevonden met deze filters.",
    renewal_tracking_partial: "Verlengingen worden bijgehouden sinds {date}. Abonnementen die vóór die datum zonder verlenging zijn verlopen, staan hier niet.",
    renewal_tracking_pending: "Het bijhouden van verlengingen start bij de volgende nachtelijke synchronisatie. Tot dan verdwijnen abonnementen die zonder verlenging verlopen van deze pagina.",
    renewal_load_failed: "Verlengingsstatus laden mislukt.",
    error_invalid_month: "Ongeldige maand.",

    // Admin Renewals Summary
    admin_renewals_summary: "Verlengingsoverzicht",
    renewals_summary_description: "Overzicht van aanstaande verlengingen en totaal aantal licenties gegroepeerd per kalenderweek.",
    quick_info_suspended_title: "Opgeschorte Klanten (±2w)",
    quick_info_going_suspend_title: "Dreigt Opgeschort te Worden (±2w)",
    quick_info_suspended_desc: "Reeds opgeschorte Google Workspace accounts binnen ±2 weken van de huidige week.",
    quick_info_going_suspend_desc: "Actieve accounts binnen ±2 weken zonder automatische verlenging (stopt op einddatum / handmatig).",
    quick_info_customers: "klanten",
    quick_info_licenses: "licenties",
    quick_info_view_list: "Bekijk Lijst",
    quick_info_filter_table: "Filter Tabel",
    quick_info_filtering: "Gefilterd",
    quick_info_suspended_modal_title: "Opgeschorte Klanten (±2 weken)",
    quick_info_going_suspend_modal_title: "Klanten die dreigen te worden opgeschort (±2 weken)",
    sku: "SKU / Product",
    total_licenses: "Totaal",
    customer_details: "Klantgegevens",
    customer_name: "Klantnaam",
    domain: "Domein",
    close_details: "Sluiten",
    filter_all: "Alles",
    filter_past_weeks: "Verstreken (-2w / -1w)",
    filter_suspended_2w: "Opgeschort (±2w)",
    filter_going_suspend_2w: "Dreigt Opgeschort (±2w)",
    filter_7_days: "≤ 7 Dagen",
    filter_15_days: "≤ 15 Dagen",
    filter_30_days: "≤ 30 Dagen",
    filter_60_days: "≤ 60 Dagen",
    filter_90_days: "≤ 90 Dagen",
    current_week: "Huidige week",
    past_week: "Verstreken week",
    renew_days_ago: "{days} dagen geleden verlopen",
    search_customer: "Zoek klant...",
    check_renewals: "Verlengingen Controleren",
    check_renewals_started: "Het controleren van verlengingen op de achtergrond is gestart!",

    admin_orders_dashboard: "Bestellingen Dashboard",
    admin_orders_dashboard_description: "Overzicht van alle bestellingen.",
    loading_dashboard_data: "Dashboard gegevens laden...",
    monthly_revenue: "Maandelijkse Omzet (€)",
    payment_platforms: "Betalingsplatforms (Bestellingen)",
    top_customers_revenue: "Top Klanten op Omzet (€)",
    revenue: "Omzet",
    top_cart_items_revenue: "Top Cart Items op Omzet (€)",
    monthly_flex_domain_revenue: "Flex Plan Omzet per Domein (€)",
    monthly_gcp_domain_revenue: "GCP Omzet per Domein (€)",
    top_flex_items_revenue: "Top Flex Plan Items op Omzet (€)",
    current_month_revenue: "Huidige Maand Omzet",

    // Admin Login History
    admin_login_history: "Login Geschiedenis",
    admin_login_history_description: "Overzicht van actieve gebruikers en recente logins.",
    login_overview: "Login Kalender Overzicht",
    logins_recorded: "logins geregistreerd in de actieve periode",
    less: "Minder",
    more: "Meer",
    ip_address: "IP Adres",
    user_agent: "User Agent",
    role: "Rol",
    name: "Naam",
    email: "E-mail",

    // Admin Peppol Invoices
    admin_peppol_invoices: "Peppol Facturen",
    admin_peppol_invoices_description: "Status van Peppol e-facturen verzonden via Maventa.",
    peppol_status: "Peppol Status",
    peppol_destination: "Bestemming",
    peppol_recipient: "Ontvanger",
    peppol_actions_timeline: "Bezorging tijdlijn",
    peppol_refresh: "Vernieuwen",
    peppol_refresh_failed: "Vernieuwen mislukt",
    peppol_refresh_disabled_hint: "Nog geen Maventa-id — eerst Opnieuw verzenden",
    peppol_resend: "Opnieuw verzenden",
    peppol_resend_failed: "Opnieuw verzenden mislukt",
    peppol_resend_success: "Peppol-factuur opnieuw verzonden",
    peppol_resend_confirm: "Peppol-factuur opnieuw verzenden voor order {{order_id}}?",
    peppol_not_sent: "Niet Verzonden",
    peppol_incomplete_label: "Btw-nr ontbreekt",
    peppol_action_needed: "Actie vereist",
    peppol_reason_missing_customer_vat: "De klant heeft geen btw-nummer, dus er kon geen Peppol-adres worden opgebouwd. Voeg het btw-nummer toe aan de klantgegevens en klik daarna op Opnieuw verzenden.",
    peppol_not_configured_label: "Niet geconfigureerd",
    peppol_not_generated_label: "Nog niet gegenereerd",
    peppol_not_attempted_label: "Peppol niet geprobeerd",
    peppol_pdf_unavailable_label: "PDF niet beschikbaar",
    peppol_not_attempted_message: "Deze factuur is gegenereerd maar er is nooit een Peppol-verzending geregistreerd. Klik op Opnieuw verzenden om hem nu te versturen.",
    peppol_reason_maventa_not_configured: "Maventa is niet geconfigureerd op deze omgeving, dus de Peppol-verzending is overgeslagen. Stel de MAVENTA_*-omgevingsvariabelen in op de backend en klik daarna op Opnieuw verzenden.",
    peppol_reason_auto_invoice_disabled: "Automatische facturatie is uitgeschakeld voor deze klant, dus de Peppol-verzending is overgeslagen.",
    error_auto_invoice_disabled: "Automatische facturatie is uitgeschakeld voor deze klant. Schakel Automatische facturatie in bij de klant om naar Peppol te verzenden.",
    peppol_reason_pdf_unavailable: "De factuur-PDF kon niet worden gegenereerd, dus de Peppol-verzending is overgeslagen. Genereer de factuur opnieuw en klik daarna op Opnieuw verzenden.",
    peppol_reason_maventa_rejected: "Maventa heeft de factuur geweigerd (zie de foutdetails hieronder). Los het gemelde probleem op en klik daarna op Opnieuw verzenden.",
    peppol_reason_auth_error: "Authenticatie bij Maventa is mislukt (tokenverzoek mislukt). Controleer de Maventa-inloggegevens en klik daarna op Opnieuw verzenden.",
    peppol_reason_network_error: "Kon Maventa niet bereiken (netwerkfout). Probeer opnieuw te verzenden; als het probleem aanhoudt, controleer de verbinding.",
    peppol_reason_xml_build_error: "De factuur kon niet worden omgezet naar Peppol-UBL (zie de foutdetails hieronder). Dit betekent meestal dat order-/klantgegevens ontbreken.",
    peppol_reason_generation_error: "Het genereren van de factuur is mislukt vóór de Peppol-verzending (zie de foutdetails hieronder). Los de fout op en klik daarna op Opnieuw verzenden.",
    pdf: "PDF",
    peppol_attempts_history: "Pogingen geschiedenis",
    peppol_attempt_detail: "Detail",
    peppol_syncing_pending: "Facturen onderweg worden gecontroleerd bij Maventa…",
    peppol_outcome_seen_at: "uitkomst gezien {{when}}",
    peppol_details: "Peppol details",
    peppol_recipient_email: "E-mailadres ontvanger",
    sent_by_email_to: "Verzonden per e-mail naar",
    action_created_label: "Aangemaakt",
    order_nr: "Order Nr",
    customer: "Klant",
    created_at: "Aangemaakt",
    environment: "Omgeving",
    channel: "Kanaal",
    event: "Gebeurtenis",
    message: "Bericht",
    happened_at: "Tijdstip",
    no_actions: "Nog geen acties.",
    error: "Fout",

    // Admin AFAS Transactions
    admin_afas_transactions: "AFAS Transacties",
    admin_afas_transactions_description: "Overzicht van gesynchroniseerde AFAS transacties.",
    confirm_delete_all_collections: "Dit verwijdert gegevens uit de orders, afas_transactions en transactions collecties. Weet u het heel zeker?",
    missing_order: "Ontbrekende Order ID",
    submit: "Verzenden",
    submitting: "Verzenden...",
    submit_success: "Bestelling succesvol naar AFAS verzonden!",
    afas_lines_count: "Aantal Regels",
    last_synced_at: "Laatst Gesynchroniseerd",
    voucher_nr: "Voucher Nr",
    order_information: "Orderinformatie",
    customer_id: "Klant-ID",
    order_user: "Besteller",
    payment_method: "Betaalmethode",
    receipt: "Betaalbewijs",
    view_receipt: "Bekijk betaalbewijs",
    afas_journal_id: "AFAS Journaal-ID",
    vat_amount: "BTW-bedrag",
    total_price: "Totaalprijs",
    cart_items: "Winkelmandje Items",
    unit_price: "Stukprijs",
    account: "Grootboek",
    description: "Omschrijving",
    period: "Periode",
    cost_center: "Kostenplaats",
    amount: "Bedrag",
    journal_1: "Journaal 1 (Verkopen)",
    journal_2: "Journaal 2 (Overlopende posten)",
    other_afas_lines: "Andere AFAS regels",
    grid: "RASTER",
    table: "TABEL",
    loading_order_details: "Ordergegevens laden...",
    multiple_lines_summed: "Meerdere transacties gesummeerd",

    missing_product_id: "Ontbrekend product-ID in winkelmandje.",
    missing_sku_id: "Ontbrekende SKU-ID voor licentie-item.",
    license_product_not_found: "Geen catalogusproduct gevonden voor licentie-SKU.",
    product_not_found_catalog: "Product niet gevonden in de catalogus.",
    price_mismatch_error: "Prijsverschil gedetecteerd. Verfris je winkelmandje.",
    order_total_zero_error: "Besteltotaal moet groter zijn dan nul.",
    payment_system_not_configured: "Betalingssysteem is niet geconfigureerd.",
    order_id_generation_failed: "Aanmaken Order ID mislukt.",
    order_below_minimum_error: "Besteltotaal is onder het minimumbedrag (€0,50).",
    payment_amount_mismatch_error: "Betalingsbedrag komt niet overeen. Probeer het opnieuw.",
    payment_processing_error: "Fout bij verwerken van betaling. Probeer het opnieuw.",
    price_not_found: "Kan prijs niet bepalen voor dit item.",
    invalid_json_payload: "Ongeldige gegevens ontvangen.",
    invalid_cart_items: "Winkelmandje is leeg of ongeldig.",
    missing_required_key: "Ontbrekende informatie in verzoek.",
    unsupported_payment_method: "Niet-ondersteunde betalingsmethode.",

    // Admin Customers Dashboard
    admin_customers: "Klanten Dashboard",
    admin_customers_description: "Overzicht en gedetailleerde controle van alle klanten.",
    sync_now: "Nu synchroniseren",
    syncing: "Synchroniseren…",
    sync_now_tooltip: "Voer nu de volledige klantsynchronisatie uit (Google Workspace + JIRA + AFAS)",
    sync_now_title: "Klantsynchronisatie starten?",
    sync_now_message: "De volledige klantsynchronisatie draait op de achtergrond (Google Workspace + JIRA + AFAS).\n\nDebiteurnamen, adressen, btw-nummers en contact-e-mails worden vanuit AFAS bijgewerkt. Dit kan enkele minuten duren.\n\nVolg de voortgang via \"Sync Customers Logs\".",
    sync_now_confirm: "Synchronisatie starten",
    starting_sync: "Klantsynchronisatie starten...",
    sync_started: "Klantsynchronisatie op de achtergrond gestart. Volg de voortgang in 'Sync Customers Logs'.",
    sync_failed: "Kan klantsynchronisatie niet starten.",
    sync_customer_tooltip: "Deze klant nu synchroniseren met AFAS",
    sync_customer_title: "Deze klant synchroniseren?",
    sync_customer_message: "Haalt de meest recente debiteurnaam, adres, btw-nummer en contact-e-mails voor deze klant op uit AFAS.\n\nBestaande contact-e-mails blijven behouden; alleen ontbrekende worden toegevoegd.",
    starting_customer_sync: "Klant synchroniseren met AFAS...",
    customer_synced: "Klant gesynchroniseerd met AFAS.",
    customer_sync_failed: "Synchroniseren van klant mislukt.",
    cd_back_to_customers: "Terug naar klanten",
    cd_customer_not_found: "Klant niet gevonden",
    cd_customer_not_found_desc: "Het geselecteerde klantrecord kon niet worden geladen.",
    cd_customer_details: "Klantgegevens",
    cd_no_name: "Geen naam",
    cd_account_settings: "Accountinstellingen",
    cd_has_access: "Toegang",
    cd_no_access: "Geen toegang",
    auto_invoice_on: "Auto Factuur AAN",
    auto_invoice_off: "Auto Factuur UIT",
    skipped: "Overgeslagen",
    cd_toggle: "Wisselen",
    cd_street_address: "Straatadres",
    cd_city_postal: "Plaats / Postcode",
    cd_country: "Land",
    cd_customer_type: "Klanttype",
    cd_contact_email: "Contact-e-mail",
    cd_emergency_email: "Noodcontact-e-mail",
    cd_prepaid_hour_balances: "Prepaid-urensaldo",
    cd_purchased_hours: "Gekochte uren",
    cd_remaining_hours: "Resterende uren",
    cd_hours_note: "Automatisch berekend op basis van gekochte supportpakketten en geregistreerde ticket-tijdregistratie.",
    cd_active_subscriptions: "Actieve Google Workspace-abonnementen",
    cd_sub_product: "Product / SKU-naam",
    cd_subscription_id: "Abonnements-ID",
    cd_purchased: "Gekocht",
    cd_assigned: "Toegewezen",
    cd_renewal_date: "Verlengingsdatum",
    cd_commitment_plan: "Verbintenisplan",
    cd_no_subscriptions: "Geen actieve abonnementen gevonden voor dit klantprofiel.",
    cd_debtor_match_desc: "Verificatie geslaagd. Het debiteurennummer in het klantrecord komt exact overeen met de AFAS ERP-facturatiegegevens.",
    cd_debtor_mismatch_desc: "Verificatiewaarschuwing! Er is een verschil gevonden tussen het debiteurennummer in het klantdocument en de gekoppelde AFAS-database. Controleer de onderstaande records.",
    cd_debtor_missing_desc: "Gedeeltelijk complete gegevens. Controleer of het facturatierecord uit AFAS is geïmporteerd of dat de debiteurennummers zijn geconfigureerd.",
    cd_customer_debtor_label: "Debiteurennummer in klantcollectie (afasDebtorNum)",
    cd_none: "Geen",
    cd_billing_debtor_label: "AFAS-facturatie DebtorNr",
    cd_no_record_linked: "Geen record gekoppeld",
    cd_linked: "Gekoppeld",
    cd_linked_erp_contract: "Gekoppeld ERP-facturatiecontract",
    cd_billing_source_note: "Afkomstig uit Firestore-collectie `afas_billing_information` op basis van Cloud_Indentity_Id",
    cd_end_customer_name: "Naam eindklant",
    cd_end_customer_number: "Nummer eindklant",
    cd_debtor_number: "Debiteurennummer (DebtorNr)",
    cd_cloud_identity_id: "Cloud Identity-ID",
    cd_domain: "Domein",
    cd_admin_number_name: "Administratienummer / -naam",
    cd_purchase_order: "Inkooporder (PO_Number)",
    cd_contract_start_date: "Contractstartdatum",
    cd_billing_profile_id: "Facturatieprofiel-ID",
    cd_no_billing_record: "Geen overeenkomend facturatierecord gevonden onder de ID",
    cd_timestamp: "Tijdstip",
    cd_name: "Naam",
    cd_email: "E-mail",
    cd_role: "Rol",
    cd_details: "Details",
    cd_unknown: "Onbekend",
    cd_no_logins: "Geen aanmeldingen geregistreerd voor domein",
    cd_order_id: "Order-ID",
    cd_date_created: "Aanmaakdatum",
    cd_items_count: "Aantal items",
    cd_total_charge: "Totaalbedrag",
    cd_payment_method: "Betaalmethode",
    cd_sync_state: "Synchronisatiestatus",
    cd_items: "items",
    cd_synced: "Gesynchroniseerd",
    cd_pending_sync: "Synchronisatie in behandeling",
    cd_no_orders: "Geen orders geplaatst door klant-ID",
    cd_transaction_id: "Transactie-ID",
    cd_plan_name: "Plannaam",
    cd_change_details: "Wijzigingsdetails",
    cd_type: "Type",
    cd_licenses: "licenties",
    cd_no_transactions: "Geen licentietransacties geregistreerd voor klant-ID",
    cd_view_afas_trx: "AFAS-transactiedetails bekijken",
    search_customers: "Zoek op klantnaam of domein...",
    debtor_status: "Debiteuren status",
    debtor_match: "Debiteurennummer komt overeen",
    debtor_mismatch: "Debiteurennummer komt NIET overeen",
    debtor_missing: "Ontbrekende debiteuren informatie",
    afas_debtor_nr: "AFAS Debiteurennummer (Klant)",
    billing_debtor_nr: "Billing Debiteurennummer (AFAS Info)",
    billing_info_tab: "AFAS Facturatiegegevens",
    login_history_tab: "Login Geschiedenis",
    orders_tab: "Bestellingen",
    transactions_tab: "Transacties",
    debtor_comparison: "Vergelijking Debiteurennummer",
    cloud_identity_id: "Cloud Identity ID",
    quick_selection: "Snelle selectie:",
    all_types: "Alle Types",
    all_statuses: "Alle Statussen",
    type: "Type",
    annual: "Annual",
    credit_note: "Credit Note",
    not_configured: "Niet geconfigureerd",
    no_billing_record: "Geen billing record",
    all_customers: "Alle Klanten",
    postpaid: "Postpaid",
    prepaid: "Prepaid",
    mismatch: "Mismatch",
    unset_billing_debtor: "Geen Facturatie Debiteur",
    postpaid_only: "Alleen Postpaid",
    prepaid_only: "Alleen Prepaid",
    active_only: "Alleen Actief",
    inactive_only: "Alleen Inactief",
    mismatch_only: "Alleen Mismatch",
    afas_debtor_number: "AFAS Debiteurennummer",
    afas_billing_debtor: "AFAS Facturatie Debiteur",
    license: "Licentie",
    licenses: "Licenties",
    no_licenses: "Geen Licenties",
    no_name: "Geen Naam",
    no_customers_found: "Geen klanten gevonden die aan de zoekcriteria voldoen.",
    toggle_postpaid_status: "Klik om Postpaid / Prepaid status te wijzigen",
    toggle_active_status: "Klik om Actief / Inactief status te wijzigen",
    updated_to: "gewijzigd naar",
    set_to: "ingesteld op",
    failed_update_postpaid: "Bijwerken van postpaid status mislukt.",
    failed_update_active: "Bijwerken van actief status mislukt.",
    failed_load_customers: "Laden van klanten mislukt.",
    admin_gcp: "GCP",
    admin_gcp_description: "Overzicht en beheer van Google Cloud Platform (GCP) facturatie.",
    admin_jira: "Jira",
    admin_jira_description: "Overzicht en beheer van Jira support tickets facturatie.",
    gcp_billing_management: "GCP Billing Management",
    gcp_billing_account: "Billing Account",
    gcp_project: "Project",
    gcp_cost: "Kosten",
    gcp_afas_debtor: "AFAS Debiteur",
    gcp_text: "Tekst",
    gcp_domain: "Domein",
    gcp_po_number: "PO Number",
    gcp_invoice_by: "Gefactureerd door",
    gcp_preview_data: "Preview Data",
    gcp_create_afas_invoices: "Create AFAS Invoices",
    gcp_filter_placeholder: "Filter rijen op debiteur, project of billing account...",
    gcp_total_cost: "Totale Kosten",
    gcp_matched_debtors: "Gekoppelde Debiteuren",
    gcp_unmatched_debtors: "Niet Gekoppeld",
    admin_user_guide: "Admin Gids",
    guide_subtitle: "Leer hoe u klanten, bestellingen en abonnementen beheert.",
    guide_instruction: "Klik op elk gemarkeerd gebied met {icon} voordat u op Volgende klikt.",
    step_detail: "Stap Detail",
    got_it: "Begrepen!",
    previous_step: "Vorige",
    next_step: "Volgende",
    guide_overview_title: "Dashboard Overzicht",
    guide_overview_subtitle: "Identificeer de belangrijkste onderdelen van het klantendashboard.",
    guide_ordering_postpaid_title: "Bestellen & Verlengen (Postpaid)",
    guide_ordering_postpaid_subtitle: "Leer hoe u licenties kunt verhogen of abonnementen kunt verlengen voor postpaid klanten.",
    guide_ordering_prepaid_title: "Bestellen & Verlengen (Prepaid)",
    guide_ordering_prepaid_subtitle: "Voor reguliere klanten is betaling via Stripe of PayPal vereist.",
    guide_webshop_title: "Product- & Prijsbeheer",
    guide_webshop_subtitle: "Hoe u uw webshop-catalogus up-to-date houdt.",
    guide_renewals_title: "Verlengingen Bijhouden",
    guide_renewals_subtitle: "Beheer proactief aankomende vervaldata.",
    guide_afas_title: "AFAS Integratie",
    guide_afas_subtitle: "Controleer gesynchroniseerde gegevens en PDF-facturen.",
    guide_customers_title: "Klantenbeheer",
    guide_customers_subtitle: "Onderhoud klantgegevens en facturatie-instellingen.",

    // Hotspots
    hs_customer_selector_title: "Klantselectie",
    hs_customer_selector_desc: "Selecteer hier altijd uw doelklant voordat u actie onderneemt. Dit filtert alle gegevens op de pagina.",
    hs_postpaid_toggle_title: "Postpaid Schakelaar",
    hs_postpaid_toggle_desc: "Controleer of de klant Postpaid is. Postpaid-klanten hoeven niet te betalen bij het afrekenen; zij worden later gefactureerd via AFAS.",
    hs_support_hours_title: "Supporturen",
    hs_support_hours_desc: "Bekijk de resterende supporturen voor deze klant. Dit wordt in realtime bijgewerkt wanneer zij supportpakketten aanschaffen.",
    hs_existing_subs_title: "Bestaande Abonnementen",
    hs_existing_subs_desc: "Deze tabel toont actieve Google-licenties. Gebruik het aantal-veld en het winkelmandje-icoon om licenties te VERHOGEN.",
    hs_renew_btn_title: "Verlengknop",
    hs_renew_btn_desc: "Klik op deze rode knop om een abonnement met een jaar te verlengen.",
    hs_new_subs_title: "Nieuwe Abonnementen (Jaarlijks)",
    hs_new_subs_desc: "Scroll naar beneden naar het 'Workspace Abonnements'-raster om een NIEUW product te kopen dat de klant nog niet heeft.",
    hs_increase_lic_title: "Licenties Verhogen",
    hs_increase_lic_desc: "Voer het nieuwe aantal in dat u wilt toevoegen. Zorg ervoor dat het abonnement nog actief is.",
    hs_place_order_title: "Bestelling Plaatsen",
    hs_place_order_desc: "Klik op dit icoon om de bestelling af te ronden. Postpaid-klanten kunnen bestellen zonder directe betaling.",
    hs_payment_methods_title: "Betaalmethoden",
    hs_payment_methods_desc: "Kies tussen Creditcard (Stripe) of PayPal. Uw licenties worden direct na succesvolle betaling bijgewerkt.",
    hs_price_updates_title: "Prijsupdates",
    hs_price_updates_desc: "Klik op het bewerk-icoon om de prijs te wijzigen. Als de prijs 0 is, is het item onzichtbaar voor klanten.",
    hs_tech_sku_title: "Technische SKU",
    hs_tech_sku_desc: "Deze SKU moet overeenkomen met de Google Reseller SKU. Dit verbindt onze shop met de Google API.",
    hs_add_item_title: "Nieuw Item Toevoegen",
    hs_add_item_desc: "Gebruik deze knop om een nieuwe Google Workspace SKU of een Supportpakket aan de portal toe te voegen.",
    hs_weekly_sum_title: "Wekelijks Overzicht",
    hs_weekly_sum_desc: "Zie hoeveel licenties er elke week verlopen voor alle klanten.",
    hs_drilldown_title: "Gedetailleerde Analyse",
    hs_drilldown_desc: "Klik op een getal om te zien welke klant precies in die specifieke week verloopt.",
    hs_sync_status_title: "Sync Status",
    hs_sync_status_desc: "Controleer of de bestelling succesvol naar AFAS is gepusht.",
    hs_invoice_pdf_title: "Factuur PDF",
    hs_invoice_pdf_desc: "Klik op het PDF-icoon om de exacte factuur te bekijken die in de AFAS-omgeving is geplaatst.",
    hs_customer_list_title: "Klantenlijst",
    hs_customer_list_desc: "Zoek en filter alle klanten die in de portal worden beheerd.",
    hs_debtor_nr_title: "Debiteurennummer",
    hs_debtor_nr_desc: "Zorg ervoor dat het AFAS-debiteurennummer correct is voor nauwkeurige facturatie.",

    // Create Order Modal
    create_order: "Create Order",
    create_order_subtitle: "Maak een ontbrekende bestelling aan zodat de klant kan betalen.",
    current_customer_subscriptions: "Huidige abonnementen van klant (klik om in te vullen)",
    use_subscription: "+ Gebruik",
    selected: "✓ Geselecteerd",
    order_items: "Orderregels",
    license_start_date: "Startdatum licentie",
    license_end_date: "Einddatum licentie",
    year: "jaar",
    create_order_pay_hint: "De bestelling wordt aangemaakt als 'Pending Payment' (openstaand), zodat de klant via de Betaalknop in Bestelgeschiedenis kan afrekenen.",
    create_order_success: "Bestelling succesvol aangemaakt",
    subscription_applied: "Abonnement ingevuld in orderregel",
    skip_reseller_api_checkbox: "Handmatige Google-verwerking (sla Google API over bij betaling)",
    skip_reseller_api_desc_checked: "Google API wordt overgeslagen bij betaling (handig als licenties al handmatig zijn heractiveerd in Google Admin Console).",
    skip_reseller_api_desc_unchecked: "Google API zal licenties automatisch heractiveren en verlengen zodra de klant betaalt.",
  },
  en: {
    // --- Access refusals -------------------------------------------------
    // Keyed by the `error` code the backend returns (route_guard.py), not by
    // the English sentence beside it. utils/apiErrors.js looks here first and
    // falls back to the server's `message` field.
    error_insufficient_permissions: "Your account has read-only access, so it cannot make changes here.",
    error_access_denied: "Your account does not have access to this tool. Ask a SuperAdmin to add you.",
    error_domain_not_recognized: "Your organization is not registered in this portal. Ask your Xebia contact to arrange access.",
    error_no_hosted_domain: "Sign in with your organization's work account. Personal Google accounts cannot be used here.",
    error_access_disabled: "Your account's access has been disabled.",
    error_invalid_role: "Your account has an unrecognised role. Contact a SuperAdmin.",
    error_customer_out_of_scope: "You do not have access to this customer.",
    error_field_not_editable: "Some of those details can only be changed by us. Please contact support.",
    error_endpoint_not_authorized: "That action is not available.",
    error_missing_bearer_token: "Your session has expired. Please sign in again.",
    error_invalid_token: "Your session has expired. Please sign in again.",
    error_internal_server_error: "An unexpected error occurred.",
    error_firestore_unavailable: "The database is briefly unavailable. Please try again.",
    readonly_notice: "You can view everything on this page, but you do not have permission to make changes here, so actions that change data are hidden.",
    profile_readonly_notice: "Your account can view these details but not change them. Ask an administrator if something needs updating.",

    // Header & General
    logout: "Logout",
    tour_button: "Tour",
    summon_tour: "Start Tour Guide",
    tour_customer_selector: "Select a customer to view their dashboard.",
    tour_customer_summary: "View the basic details of the selected customer here.",
    tour_subscriptions_table: "Manage active subscriptions, renew, or increase licenses.",
    tour_cart: "Review items in your cart and complete your order.",
    tour_extra_products: "Explore and add additional products to your cart.",
    joyride_back: "Back",
    joyride_close: "Close",
    joyride_last: "Last",
    joyride_next: "Next",
    joyride_skip: "Skip",
    loading: "Loading...",
    not_applicable: "N/A",
    no_data_found: "No data found.",

    // Login Page
    login_title: "Reseller Portal",
    login_message: "Please log in to continue.",

    // Main Page
    my_overview: "My Overview",
    primary_domain: "Primary Domain",
    support_hours: "Available Support Hours",
    customer_selection: "Customer Selection",
    choose_customer: "Choose customer",
    has_access: "Has Access",
    no_access: "No Access",
    postpaid_customer: "Postpaid Customer",
    prepaid_customer: "Prepaid Customer",
    active: "Active",
    inactive: "Inactive",
    saved: "Saved.",
    save_failed: "Failed to save.",
    save: "Save",
    cancel: "Cancel",
    loading_details: "Loading details...",
    closed_tickets: "Closed Tickets",
    ticket_key: "Ticket ID",
    summary: "Subject",
    date: "Date",
    time_spent: "Time Spent",
    no_tickets_found: "No tickets found.",
    close: "Close",
    hours: "hours",
    minutes: "minutes",
    max_hours_error: "Cannot exceed 40 hours in cart.",

    // Products Table
    product: "Product",
    total: "Total",
    in_use: "In Use",
    renewal_date: "Renewal Date",
    add_licenses: "Add Licenses",
    add_to_cart: "Add to cart",
    subscribe_to_annual: "Subscribe (annual)",
    per_license_year: "per license / year",
    added_to_cart: "Licenses added to cart!",
    no_renewable_licenses: "No renewable licenses found.",
    no_prices_found: "Could not determine prices for any licenses.",
    renewal_items_skipped: "No price found for: {items}. These were not added.",
    calculating_renewal_cost: "Calculating total renewal cost...",
    error_calculating_renewals: "Error calculating renewals.",
    payment_system_not_ready: "Payment system is not ready. Please try again later.",
    quantity_placeholder: "Quantity",
    extra_products_and_services: "Extra products & services",
    cant_find_product: "Can't find the product you need?",
    request_custom_order: "Request Custom Order",
    additional_notes: "Additional Notes",
    submit_request: "Submit Request",
    sending: "Sending",
    describe_request: "Describe your request",
    renew_reminder: "Renew in {days} days",
    renewal: "Renewal",
    renew_all_licenses: "Renew all licenses",
    auto_renew: "Auto renew",

    // Extra Products
    extra_products_services: "Extra Products and Services",

    // Shopping Cart
    shopping_cart: "Shopping Cart",
    empty_cart: "Your shopping cart is empty.",
    added_to_cart_success: "has been added to your shopping cart.",
    item: "Item",
    quantity: "Quantity",
    action: "Action",
    remove: "Remove",
    place_order: "Place Order",
    order_placed_success: "Order placed successfully!",
    cannot_place_order_alert: "Cannot place order: no customer selected or cart is empty.",
    order_placed_success_message: "Order placed successfully! Order ID:",
    payment_success_invoice_email: "Payment successful. The invoice will be sent to your email.",
    payment_success_processed: "Payment successful. Your order has been processed.",
    payment_failed_authentication: "The payment failed or was cancelled. Please try again or use another payment method.",
    order_placed_error: "An error occurred while placing the order.",
    success_title: "Success",
    error_title: "Error",
    payment_details: "Payment Details",
    yearly_price: "Yearly price",
    remain_days: "Remaining days",
    subtotal: "Subtotal",
    vat: "VAT",
    purchase_order: "Purchase Order (Optional)",

    order_history: "Order History",
    back_to_dashboard: "Back to Dashboard",
    invoice_number: "Invoice Number",
    status: "Status",
    view_invoice: "View Invoice",
    no_orders_found: "No orders found.",
    total_amount: "Total Amount",
    ordered_by: "Ordered By",
    pay: "Pay",
    pay_with_stripe: "Pay with Stripe",
    paying: "Processing...",
    copy_payment_link: "Copy payment link",
    payment_link_copied: "Payment link copied to clipboard!",
    copied: "Copied!",
    tc_agree: "I agree to the",
    tc_terms: "Terms and Conditions",
    tc_error: "Please agree to the Terms and Conditions to proceed.",

    // Public payment page
    payment_page_title: "Invoice Payment",
    order_details: "Order Details",
    invoice_for_order: "Invoice for order",
    item_name: "Name",
    item_description: "Description",
    item_price: "Price (€)",
    item_quantity: "Quantity",
    item_subtotal: "Subtotal",
    order_already_paid: "This invoice has already been paid.",
    order_already_paid_desc: "Thank you for your payment. Your services and licenses are being processed automatically.",
    download_invoice_pdf: "Download Invoice (PDF)",
    order_not_found: "Order not found",
    order_not_found_desc: "The requested invoice or order could not be found. Please check the invoice number in the URL or contact support.",
    secure_payment_stripe_desc: "Secure checkout via Stripe (supports iDEAL, Credit Card, Bancontact and more).",
    payment_successful: "Payment processed successfully!",
    payment_cancelled: "Payment cancelled. You can try again whenever you are ready.",
    thank_you_payment_for: "Thank you for the payment for",
    payment_success_desc: "Your payment has been successfully received. Your Google Workspace licenses and services are being automatically updated and reactivated.",
    payment_reference: "Invoice Number",
    amount_paid: "Amount Paid",
    status_completed: "Completed & Paid",
    show_details: "View purchased items",
    hide_details: "Hide details",
    suspended_workspace_notice: "Unable to sign in due to a suspended Google Workspace account? You can pay this invoice directly below to reactivate your services.",
    need_help: "Need assistance?",
    contact_support: "Contact support",

    // Workspaces
    workspace_plans: "Workspace Subscription Plans (Annual)",
    search_workspace_plans: "Search subscription plans...",
    afas_artikelcode: "AFAS Article Code",
    price: "Price (€)",
    related_licenses_sku: "Related SKU",
    visible: "Visible",
    order: "Order",
    icon: "Icon Key",
    category: "Category",
    no_search_results: "No results found for your search.",
    load_more_failed: "Couldn't load more transactions.",
    retry: "Retry",
    related_sku: "Related SKU",
    contact_admin_to_update_price: "Please contact Administrator to update the price.",
    afas_artikelcode_empty: "AFAS article code is empty.",
    cannot_make_visible: "Cannot make visible",
    cannot_make_visible_both_reason: "price is €0 and AFAS article code is empty",
    cannot_make_visible_price_reason: "price is €0",
    cannot_make_visible_afas_reason: "AFAS article code is empty",
    cannot_be_visible_warning: "Cannot be visible because price is €0 or AFAS article code is empty.",
    admin_webshop: "Webshops",
    actions: "Actions",
    add_new_item: "Add New Item",
    edit_item: "Edit Item",
    delete_item_confirmation: "Are you sure you want to delete this item?",
    delete: "Delete",
    saving: "Saving...",
    save_changes: "Save Changes",
    no_item_found: "No items found.",
    sku_help_text: "Need SKU or Product IDs? Check the ",
    google_workspace_docs: "Google Workspace Docs",
    google_reseller_docs: "Google Reseller Docs",
    no_subscriptions_found: "No active subscriptions found for this customer.",
    profile: "Profile",
    customer_name_placeholder: "Enter company or customer name",
    address1: "Address Line 1",
    address1_placeholder: "Unit, floor or office number, street name and number",
    address2: "Address Line 2",
    address2_placeholder: "Postcode and city",
    country: "Country",
    country_placeholder: "Enter country (e.g., Netherlands)",
    contact_email: "Contact Email",
    contact_email_placeholder: "billing@example.com, info@example.com",
    contact_email_hint: "Separate multiple emails with commas",
    profile_saved: "Profile saved successfully",
    profile_save_error: "Failed to save profile",
    changes_discarded: "Changes discarded",
    vat_number: "VAT Number",
    vat_number_placeholder: "VAT number (e.g., NL123456789B01)",
    vat_validating: "Validating VAT number...",
    vat_valid: "VAT number is valid",
    vat_invalid: "VAT number is not valid",
    vat_validation_error: "VAT validation unavailable",
    vat_mismatch_warning: "Warning: Company name or address differs from VAT registry",
    emergency_email: "Emergency Email",
    emergency_email_placeholder: "emergency@example.com",
    emergency_email_hint: "Emergency contact email that is outside of your domain.",

    admin_email_template: "E-mailtemplates",

    // Renewal Reminders
    renewal_reminders: {
      days_30: "Time to renew! Your Google Workspace licenses expire in 30 days. Click here to settle your invoice and prevent service interruptions.",
      days_15: "Reminder: Your licenses expire in 15 days. Avoid domain deactivation by paying now in the Xebia webshop.",
      days_7: "Important: Only 7 days until expiry. We haven't received your payment yet. The Phoenix team has been notified for follow-up.",
      days_2: "LAST CHANCE: Your Google Workspace access will stop in 48 hours. Pay immediately to avoid data loss.",
      days_0: "Access Suspended: Your licenses have expired. Your services are now inactive. Pay today to reactivate your account.",
      lost: "Account Lost: Due to non-payment, your subscription has been terminated. Contact support for potential recovery options."
    },

    // Admin Renewal Status
    admin_renewal_status: "Renewal Status",
    renewal_status_description: "Which customers are due to renew this month, and whether they have.",
    renewal_due: "Due",
    renewal_renewed: "Renewed",
    renewal_open: "Open",
    renewal_payment_pending: "Payment pending",
    renewal_not_renewed: "Not renewed",
    renewal_no_order: "Renewed without order",
    renewal_no_order_hint: "Google renewed it, but there is no paid or invoiced order.",
    renewal_switched: "Switched to flexible",
    range_start: "Start",
    range_today: "Today",
    renewal_setting_renew: "Auto-renews",
    renewal_setting_cancel: "Cancels at end date",
    renewal_setting_switch: "Switches to flexible plan",
    renewal_progress: "{renewed}/{total} renewed",
    renewal_subscriptions: "Subscriptions",
    renewal_type: "Type",
    renewal_type_col: "Renewal Type",
    renewal_order: "Order",
    renewal_other_month: "Other month",
    renewal_none: "No customers are due to renew in this month.",
    renewal_none_filtered: "No customers match these filters.",
    renewal_tracking_partial: "Renewals are tracked since {date}. Subscriptions that expired without renewal before that date are not shown.",
    renewal_tracking_pending: "Renewal tracking starts with the next nightly sync. Until then, subscriptions that expire without renewal disappear from this page.",
    renewal_load_failed: "Failed to load renewal status.",
    error_invalid_month: "Invalid month.",

    // Admin Renewals Summary
    admin_renewals_summary: "Renewals Summary",
    renewals_summary_description: "Overview of upcoming renewals and total licenses grouped by calendar week.",
    quick_info_suspended_title: "Suspended Customers (±2w)",
    quick_info_going_suspend_title: "Going to Suspend (±2w)",
    quick_info_suspended_desc: "Already suspended Google Workspace accounts within ±2 weeks of current week.",
    quick_info_going_suspend_desc: "Active accounts within ±2 weeks with auto-renew OFF (set to cancel / manual renewal required).",
    quick_info_customers: "customers",
    quick_info_licenses: "licenses",
    quick_info_view_list: "View List",
    quick_info_filter_table: "Filter Table",
    quick_info_filtering: "Filtering",
    quick_info_suspended_modal_title: "Suspended Customers (±2 weeks)",
    quick_info_going_suspend_modal_title: "Customers Going to Suspend (±2 weeks)",
    sku: "SKU / Product",
    total_licenses: "Total",
    customer_details: "Customer Details",
    customer_name: "Customer Name",
    domain: "Domain",
    close_details: "Close",
    filter_all: "All",
    filter_past_weeks: "Past (-2w / -1w)",
    filter_suspended_2w: "Suspended (±2w)",
    filter_going_suspend_2w: "Going to Suspend (±2w)",
    filter_7_days: "≤ 7 Days",
    filter_15_days: "≤ 15 Days",
    filter_30_days: "≤ 30 Days",
    filter_60_days: "≤ 60 Days",
    filter_90_days: "≤ 90 Days",
    current_week: "Current week",
    past_week: "Past week",
    renew_days_ago: "Expired {days} days ago",
    search_customer: "Search customer...",
    check_renewals: "Check Renewals",
    check_renewals_started: "The background job to check renewals has started!",

    admin_orders_dashboard: "Orders Dashboard",
    admin_orders_dashboard_description: "Overview of all orders.",
    loading_dashboard_data: "Loading dashboard data...",
    monthly_revenue: "Monthly Revenue (€)",
    payment_platforms: "Payment Platforms (Orders)",
    top_customers_revenue: "Top Customers by Revenue (€)",
    revenue: "Revenue",
    top_cart_items_revenue: "Top Cart Items by Revenue (€)",
    monthly_flex_domain_revenue: "Flex Plan Revenue by Domain (€)",
    monthly_gcp_domain_revenue: "GCP Revenue by Domain (€)",
    top_flex_items_revenue: "Top Flex Plan Items by Revenue (€)",
    current_month_revenue: "Current Month Revenue",

    // Admin Login History
    admin_login_history: "Login History",
    admin_login_history_description: "Overview of active users and recent logins.",
    login_overview: "Login Calendar Overview",
    logins_recorded: "logins recorded in the active period",
    less: "Less",
    more: "More",
    ip_address: "IP Address",
    user_agent: "User Agent",
    role: "Role",
    name: "Name",
    email: "Email",

    // Admin Peppol Invoices
    admin_peppol_invoices: "Peppol Invoices",
    admin_peppol_invoices_description: "Status of Peppol e-invoices sent via Maventa.",
    peppol_status: "Peppol Status",
    peppol_destination: "Destination",
    peppol_recipient: "Recipient",
    peppol_actions_timeline: "Delivery Timeline",
    peppol_refresh: "Refresh",
    peppol_refresh_failed: "Refresh failed",
    peppol_refresh_disabled_hint: "No Maventa id yet — Resend first",
    peppol_resend: "Resend",
    peppol_resend_failed: "Resend failed",
    peppol_resend_success: "Peppol invoice resent",
    peppol_resend_confirm: "Resend Peppol invoice for order {{order_id}}?",
    peppol_not_sent: "Not Sent",
    peppol_incomplete_label: "Missing VAT",
    peppol_action_needed: "Action needed",
    peppol_reason_missing_customer_vat: "The customer has no VAT number, so no Peppol address could be built. Add the VAT number to the customer record, then click Resend.",
    peppol_not_configured_label: "Not configured",
    peppol_not_generated_label: "Not generated yet",
    peppol_not_attempted_label: "Peppol not attempted",
    peppol_pdf_unavailable_label: "PDF unavailable",
    peppol_not_attempted_message: "This invoice was generated but no Peppol send was ever recorded. Click Resend to send it now.",
    peppol_reason_maventa_not_configured: "Maventa is not configured on this environment, so the Peppol send was skipped. Set the MAVENTA_* environment variables on the backend, then click Resend.",
    peppol_reason_auto_invoice_disabled: "Auto Invoice is disabled for this customer, so the Peppol send was skipped.",
    error_auto_invoice_disabled: "Auto Invoice is disabled for this customer. Enable Auto Invoice on the customer before sending to Peppol.",
    peppol_reason_pdf_unavailable: "The invoice PDF could not be generated, so the Peppol send was skipped. Regenerate the invoice, then click Resend.",
    peppol_reason_maventa_rejected: "Maventa rejected the invoice (see the error detail below). Fix the reported issue, then click Resend.",
    peppol_reason_auth_error: "Could not authenticate with Maventa (token request failed). Check the Maventa credentials, then click Resend.",
    peppol_reason_network_error: "Could not reach Maventa (network error). Try Resend again; if it persists, check connectivity.",
    peppol_reason_xml_build_error: "The invoice could not be converted to Peppol UBL (see the error detail below). This usually means missing order/customer data.",
    peppol_reason_generation_error: "Invoice generation failed before the Peppol send (see the error detail below). Resolve the error, then click Resend.",
    pdf: "PDF",
    peppol_attempts_history: "Attempt history",
    peppol_attempt_detail: "Detail",
    peppol_syncing_pending: "Checking in-flight invoices with Maventa…",
    peppol_outcome_seen_at: "outcome seen {{when}}",
    peppol_details: "Peppol details",
    peppol_recipient_email: "Recipient email",
    sent_by_email_to: "Sent by email to",
    action_created_label: "Created",
    order_nr: "Order Nr",
    customer: "Customer",
    created_at: "Created",
    environment: "Environment",
    channel: "Channel",
    event: "Event",
    message: "Message",
    happened_at: "When",
    no_actions: "No actions yet.",
    error: "Error",

    // Admin AFAS Transactions
    admin_afas_transactions: "AFAS Transactions",
    admin_afas_transactions_description: "Overview of synced AFAS transactions.",
    confirm_delete_all_collections: "This will delete data from orders, afas_transactions, and transactions collections. Are you really sure?",
    missing_order: "Missing Order ID",
    submit: "Submit",
    submitting: "Submitting...",
    submit_success: "Order successfully submitted to AFAS!",
    afas_lines_count: "Lines Count",
    last_synced_at: "Last Synced At",
    voucher_nr: "Voucher Nr",
    order_information: "Order Information",
    customer_id: "Customer ID",
    order_user: "Order User",
    payment_method: "Payment Method",
    receipt: "Receipt",
    view_receipt: "View receipt",
    afas_journal_id: "AFAS Journal ID",
    vat_amount: "VAT Amount",
    total_price: "Total Price",
    cart_items: "Cart Items",
    unit_price: "Unit Price",
    account: "Account",
    description: "Description",
    period: "Period",
    cost_center: "Cost Center",
    amount: "Amount",
    journal_1: "Journal 1 (Sales)",
    journal_2: "Journal 2 (Transitory Items)",
    other_afas_lines: "Other AFAS Lines",
    grid: "GRID",
    table: "TABLE",
    loading_order_details: "Loading order details...",
    multiple_lines_summed: "Multiple transactions summed",

    missing_product_id: "Missing product ID in cart item.",
    missing_sku_id: "Missing SKU ID for license item.",
    license_product_not_found: "No catalog product found for license SKU.",
    product_not_found_catalog: "Product not found in catalog.",
    price_mismatch_error: "Price mismatch detected. Please refresh your cart.",
    order_total_zero_error: "Order total must be greater than zero.",
    payment_system_not_configured: "Payment system is not configured.",
    order_id_generation_failed: "Failed to generate Order ID.",
    order_below_minimum_error: "Order total is below the minimum charge amount (€0.50).",
    payment_amount_mismatch_error: "Payment amount mismatch. Please try again.",
    payment_processing_error: "Payment processing error occurred. Please try again.",
    price_not_found: "Could not determine price for this item.",
    invalid_json_payload: "Invalid data received.",
    invalid_cart_items: "Cart items are missing or invalid.",
    missing_required_key: "Missing required information in request.",
    unsupported_payment_method: "Unsupported payment method.",

    // Admin Customers Dashboard
    admin_customers: "Customers Dashboard",
    admin_customers_description: "Overview and detailed verification of all customers.",
    sync_now: "Sync now",
    syncing: "Syncing…",
    sync_now_tooltip: "Run the full customer sync (Google Workspace + JIRA + AFAS) now",
    sync_now_title: "Start customer sync?",
    sync_now_message: "The full customer sync runs in the background (Google Workspace + JIRA + AFAS).\n\nDebtor names, addresses, VAT numbers and contact e-mails are refreshed from AFAS. This can take a few minutes.\n\nTrack progress under \"Sync Customers Logs\".",
    sync_now_confirm: "Start sync",
    starting_sync: "Starting customer sync...",
    sync_started: "Customer sync started in the background. Track progress in 'Sync Customers Logs'.",
    sync_failed: "Failed to start customer sync.",
    sync_customer_tooltip: "Sync this customer from AFAS now",
    sync_customer_title: "Sync this customer?",
    sync_customer_message: "Pulls the latest debtor name, address, VAT number and contact e-mails for this customer from AFAS.\n\nExisting contact e-mails are kept; only missing ones are added.",
    starting_customer_sync: "Syncing customer from AFAS...",
    customer_synced: "Customer synced from AFAS.",
    customer_sync_failed: "Failed to sync customer.",
    cd_back_to_customers: "Back to Customers",
    cd_customer_not_found: "Customer Not Found",
    cd_customer_not_found_desc: "The selected customer record could not be loaded.",
    cd_customer_details: "Customer Details",
    cd_no_name: "No Name",
    cd_account_settings: "Account Settings",
    cd_has_access: "Has Access",
    cd_no_access: "No Access",
    auto_invoice_on: "Auto Invoice ON",
    auto_invoice_off: "Auto Invoice OFF",
    skipped: "Skipped",
    cd_toggle: "Toggle",
    cd_street_address: "Street Address",
    cd_city_postal: "City / Postal Code",
    cd_country: "Country",
    cd_customer_type: "Customer Type",
    cd_contact_email: "Contact Email",
    cd_emergency_email: "Emergency Email",
    cd_prepaid_hour_balances: "Prepaid Hour Balances",
    cd_purchased_hours: "Purchased Hours",
    cd_remaining_hours: "Remaining Hours",
    cd_hours_note: "Calculated automatically based on purchased support packages and registered ticket time logging.",
    cd_active_subscriptions: "Active Google Workspace Subscriptions",
    cd_sub_product: "Product / SKU Name",
    cd_subscription_id: "Subscription ID",
    cd_purchased: "Purchased",
    cd_assigned: "Assigned",
    cd_renewal_date: "Renewal Date",
    cd_commitment_plan: "Commitment Plan",
    cd_no_subscriptions: "No active subscriptions detected under this customer's profile.",
    cd_debtor_match_desc: "Verification Successful. The debtor number defined in the customer record aligns perfectly with AFAS ERP Billing data.",
    cd_debtor_mismatch_desc: "Verification Warning! A mismatch has been detected between the customer document debiteurnummer and the connected AFAS database. Please review the records below.",
    cd_debtor_missing_desc: "Partially complete data. Please verify if the billing record has been imported from AFAS or if debtor numbers are configured.",
    cd_customer_debtor_label: "Customer collection afasDebtorNum",
    cd_none: "None",
    cd_billing_debtor_label: "AFAS billing DebtorNr",
    cd_no_record_linked: "No Record Linked",
    cd_linked: "Linked",
    cd_linked_erp_contract: "Linked ERP Billing Contract",
    cd_billing_source_note: "Sourced from Firestore collection `afas_billing_information` mapping by Cloud_Indentity_Id",
    cd_end_customer_name: "End Customer Name",
    cd_end_customer_number: "End Customer Number",
    cd_debtor_number: "Debtor Number (DebtorNr)",
    cd_cloud_identity_id: "Cloud Identity ID",
    cd_domain: "Domain",
    cd_admin_number_name: "Admin Number / Name",
    cd_purchase_order: "Purchase Order (PO_Number)",
    cd_contract_start_date: "Contract Start Date",
    cd_billing_profile_id: "Billing Profile ID",
    cd_no_billing_record: "No matching billing record was found under the ID",
    cd_timestamp: "Timestamp",
    cd_name: "Name",
    cd_email: "Email",
    cd_role: "Role",
    cd_details: "Details",
    cd_unknown: "Unknown",
    cd_no_logins: "No logins recorded for domain",
    cd_order_id: "Order ID",
    cd_date_created: "Date Created",
    cd_items_count: "Items Count",
    cd_total_charge: "Total Charge",
    cd_payment_method: "Payment Method",
    cd_sync_state: "Sync State",
    cd_items: "items",
    cd_synced: "Synced",
    cd_pending_sync: "Pending Sync",
    cd_no_orders: "No orders placed by customer ID",
    cd_transaction_id: "Transaction ID",
    cd_plan_name: "Plan Name",
    cd_change_details: "Change Details",
    cd_type: "Type",
    cd_licenses: "Licenses",
    cd_no_transactions: "No seat licensing transactions recorded for customer ID",
    cd_view_afas_trx: "View AFAS Transaction Details",
    search_customers: "Search customer name or domain...",
    debtor_status: "Debtor Status",
    debtor_match: "Debtor Number Matches",
    debtor_mismatch: "Debtor Number MISMATCH",
    debtor_missing: "Missing Debtor Information",
    afas_debtor_nr: "AFAS Debtor Number (Customer)",
    billing_debtor_nr: "Billing Debtor Number (AFAS Info)",
    billing_info_tab: "AFAS Billing Information",
    login_history_tab: "Login History",
    orders_tab: "Orders",
    transactions_tab: "Transactions",
    debtor_comparison: "Debtor Number Comparison",
    cloud_identity_id: "Cloud Identity ID",
    quick_selection: "Quick selection:",
    all_types: "All Types",
    all_statuses: "All Statuses",
    type: "Type",
    annual: "Annual",
    credit_note: "Credit Note",
    not_configured: "Not Configured",
    no_billing_record: "No Billing Record",
    all_customers: "All Customers",
    postpaid: "Postpaid",
    prepaid: "Prepaid",
    mismatch: "Mismatch",
    unset_billing_debtor: "Unset Billing Debtor",
    postpaid_only: "Postpaid Only",
    prepaid_only: "Prepaid Only",
    active_only: "Active Only",
    inactive_only: "Inactive Only",
    mismatch_only: "Mismatch Only",
    afas_debtor_number: "AFAS Debtor Number",
    afas_billing_debtor: "AFAS Billing Debtor",
    license: "License",
    licenses: "Licenses",
    no_licenses: "No Licenses",
    no_name: "No Name",
    no_customers_found: "No customers found matching the search criteria.",
    toggle_postpaid_status: "Click to toggle Postpaid / Prepaid status",
    toggle_active_status: "Click to toggle Active / Inactive status",
    updated_to: "updated to",
    set_to: "set to",
    failed_update_postpaid: "Failed to update postpaid status.",
    failed_update_active: "Failed to update active status.",
    failed_load_customers: "Failed to load customers.",
    admin_gcp: "GCP",
    admin_gcp_description: "Overview and management of Google Cloud Platform (GCP) billing.",
    admin_jira: "Jira",
    admin_jira_description: "Overview and management of Jira support tickets billing.",
    gcp_billing_management: "GCP Billing Management",
    gcp_billing_account: "Billing Account",
    gcp_project: "Project",
    gcp_cost: "Cost",
    gcp_afas_debtor: "AFAS Debtor",
    gcp_text: "Text",
    gcp_domain: "Domain",
    gcp_po_number: "PO Number",
    gcp_invoice_by: "Invoice By",
    gcp_preview_data: "Preview Data",
    gcp_create_afas_invoices: "Create AFAS Invoices",
    gcp_filter_placeholder: "Filter records by debtor, project, or billing account...",
    gcp_total_cost: "Total Cost",
    gcp_matched_debtors: "Matched Debtors",
    gcp_unmatched_debtors: "Unmatched",
    admin_user_guide: "Admin User Guide",
    guide_subtitle: "Learn how to manage customers, orders, and subscriptions.",
    guide_instruction: "Click each highlighted area marked {icon} before you click Next.",
    step_detail: "Step Detail",
    got_it: "Got it!",
    previous_step: "Previous",
    next_step: "Next",
    guide_overview_title: "Dashboard Overview",
    guide_overview_subtitle: "Identify the key areas of the customer dashboard.",
    guide_ordering_postpaid_title: "Ordering & Renewing (Postpaid)",
    guide_ordering_postpaid_subtitle: "Learn how to increase licenses or extend subscriptions for postpaid customers.",
    guide_ordering_prepaid_title: "Ordering & Renewing (Prepaid)",
    guide_ordering_prepaid_subtitle: "For regular customers, payment via Stripe or PayPal is required.",
    guide_webshop_title: "Product & Price Management",
    guide_webshop_subtitle: "How to keep your webshop catalog up to date.",
    guide_renewals_title: "Renewal Tracking",
    guide_renewals_subtitle: "Proactively manage upcoming expirations.",
    guide_afas_title: "AFAS Integration",
    guide_afas_subtitle: "Review synchronized data and PDF invoices.",
    guide_customers_title: "Customers Management",
    guide_customers_subtitle: "Maintain customer records and billing settings.",

    // Hotspots
    hs_customer_selector_title: "Customer Selector",
    hs_customer_selector_desc: "Always select your target customer here before taking any action. This filters all data on the page.",
    hs_postpaid_toggle_title: "Postpaid Toggle",
    hs_postpaid_toggle_desc: "Check if the customer is Postpaid. Postpaid clients do not need to pay at checkout; they are billed later via AFAS.",
    hs_support_hours_title: "Support Hours",
    hs_support_hours_desc: "View the remaining support hours for this customer. It updates in real-time as they purchase support packages.",
    hs_existing_subs_title: "Existing Subscriptions",
    hs_existing_subs_desc: "This table shows active Google licenses. Use the quantity box and cart icon here to INCREASE licenses.",
    hs_renew_btn_title: "Renew Button",
    hs_renew_btn_desc: "Click this red button to renew a subscription for another year.",
    hs_new_subs_title: "New Subscriptions (Annual)",
    hs_new_subs_desc: "Scroll down to the 'Workspace Abonnements' grid to purchase a NEW product that the customer doesn't have yet.",
    hs_increase_lic_title: "Increase Licenses",
    hs_increase_lic_desc: "Enter the new quantity you wish to add. Make sure the subscription is still active.",
    hs_place_order_title: "Place Order",
    hs_place_order_desc: "Click this icon to finalize the order. Postpaid customers can order without payment.",
    hs_payment_methods_title: "Payment Methods",
    hs_payment_methods_desc: "Select between Credit Card (Stripe) or PayPal. Your licenses will be updated immediately after successful payment.",
    hs_price_updates_title: "Price Updates",
    hs_price_updates_desc: "Click the edit icon to change the price. If price is 0, the item will be invisible to customers.",
    hs_tech_sku_title: "Technical SKU",
    hs_tech_sku_desc: "This SKU must match the Google Reseller SKU. It is what connects our shop to the Google API.",
    hs_add_item_title: "Add New Item",
    hs_add_item_desc: "Use this button to add a new Google Workspace SKU or a Support Package to the portal.",
    hs_weekly_sum_title: "Weekly Summary",
    hs_weekly_sum_desc: "See how many licenses are expiring each week across all customers.",
    hs_drilldown_title: "Detailed Drilldown",
    hs_drilldown_desc: "Click on a number to see exactly which customer is expiring in that specific week.",
    hs_sync_status_title: "Sync Status",
    hs_sync_status_desc: "Check if the order was successfully pushed to AFAS.",
    hs_invoice_pdf_title: "Invoice PDF",
    hs_invoice_pdf_desc: "Click the PDF icon to view the exact invoice that was inserted into the AFAS environment.",
    hs_customer_list_title: "Customer List",
    hs_customer_list_desc: "Search and filter all customers managed in the portal.",
    hs_debtor_nr_title: "Debtor Number",
    hs_debtor_nr_desc: "Ensure the AFAS Debtor number is correct for accurate invoicing.",

    // Create Order Modal
    create_order: "Create Order",
    create_order_subtitle: "Create a missing order so the customer can pay.",
    current_customer_subscriptions: "Current Customer Subscriptions (click to populate)",
    use_subscription: "+ Use",
    selected: "✓ Selected",
    order_items: "Order Items",
    license_start_date: "License Start Date",
    license_end_date: "License End Date",
    year: "year",
    create_order_pay_hint: "Order will be created with 'Pending Payment' status so the customer can click Pay in Order History.",
    create_order_success: "Order created successfully",
    subscription_applied: "Subscription applied to order item",
    skip_reseller_api_checkbox: "Manual Google handling (skip Google API upon payment)",
    skip_reseller_api_desc_checked: "Google API will NOT be triggered upon payment (useful if you already reactivated or configured the licenses in Google Admin Console).",
    skip_reseller_api_desc_unchecked: "Google API will automatically reactivate and renew licenses once customer payment succeeds.",
  },
};
